import { ReactElement } from 'react';
import { Typography } from '@legacy/components/mui-components';
import { Spinner } from '@legacy/components/ui-components/Spinner';

interface IResponseHandler {
  children: ReactElement | null;
  EmptyComponent?: ReactElement;
  ErrorComponent?: ReactElement;
  FreshComponent?: ReactElement;
  isEmpty?: boolean;
  isError?: boolean;
  /**
   * Fresh means no data fetching has occured yet
   */
  isFresh?: boolean;
  isLoading?: boolean;
  LoadingComponent?: ReactElement;
}

export const ResponseHandler = ({
  children,
  EmptyComponent,
  ErrorComponent,
  FreshComponent,
  isEmpty,
  isError,
  isFresh,
  isLoading,
  LoadingComponent,
}: IResponseHandler) => {
  if (isFresh) {
    return (
      FreshComponent || (
        <Typography data-automation-id="DefaultSuspenseFresh">
          Please choose your search criteria
        </Typography>
      )
    );
  }
  if (isLoading) {
    return (
      LoadingComponent || (
        <Spinner data-automation-id="DefaultSuspenseLoading" />
      )
    );
  }
  if (isError) {
    return (
      ErrorComponent || (
        <Typography data-automation-id="DefaultSuspenseError">
          Network Error
        </Typography>
      )
    );
  }
  if (isEmpty) {
    return (
      EmptyComponent || (
        <Typography data-automation-id="DefaultSuspenseEmpty">
          Data is empty
        </Typography>
      )
    );
  }
  return children;
};
